import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-4 py-24 text-center md:px-6">
      <span className="font-heading text-7xl font-black text-background-300 select-none md:text-9xl">
        404
      </span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        这个页面还没有内容
      </h1>
      <p className="mt-2 font-label text-sm text-foreground-500">{location.pathname}</p>
      <p className="mt-4 text-sm text-foreground-600">
        该页面可能已调整或链接有误，返回首页继续浏览《年轻的母亲2》的内容吧。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-home-4-line text-base"></i>
          </span>
          返回首页
        </Link>
        <Link
          to="/episodes"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览全部剧集
        </Link>
      </div>
    </div>
  );
}